export default {
  All: 'All',
  Rented: 'Rented',
  Idle: 'Idle',
  meau: {
    back: 'Resmi Siteye Geri Dön',
    nav1: 'Orion Yarışması',
    nav2: 'Uzun Dönem Kiralama Modu',
    nav3: 'Kısa Dönem Kiralama Modu',
    nav4: 'Cihaz Listesi',
  },
  footer: {
    link: 'Daha fazla bilgi edinin',
    community: 'Topluluğu takip edin',
    tip: "Açıklama: Topluluk Twitter, Telegram, Reddit, Medium, Discord, TikTok, YouTube'u içerir",
  },

  home: {
    title1: 'Orion',
    title2: 'GPU Hesaplama Gücü Yarışması',
    text: "DeepLink Protokolü kapsamındaki Orion GPU İşlem Gücü Yarışması, madencilerin DeepLink ağ testi sürecine aktif olarak katılmalarını teşvik etmeyi amaçlayan önemli bir teşvik yarışmasıdır. Bu yarışma, dünyanın en büyük bulut oyun protokol platformu olan DeepLink'in resmi lansmanı öncesindeki önemli bir hazırlık adımı olup, gelecekteki küresel kullanıcılar için sağlam bir teknik altyapı ve verimli işlem gücü desteği sağlar",
    text1: 'Şu anda DeepLink ağındaki toplam GPU sayısı {gpu_num}',
    text2: 'Yarışma başladı ve GPU sayısı standarda ulaştığında ödüller başlayacak!',
    btn_text1: 'Uzun Vadeli Kiralama Modu Yarışması - Sona Erdi',
    btn_title1: 'Mevcut {long_term} GPUs',
    btn_text2: 'Kısa vadeli kiralama modu yarışması - 4. Aşama',

    btn_title2: 'Güncel {short_term} GPUs',
    cont2_text1:
      "Orion hesaplama gücü yarışmasının toplam ödül miktarı 3 milyar token olup, uzun dönem kiralama modu için 2 milyar DLC ve kısa dönem kiralama modu için 1 milyar DLC'dir. Yarışma 180 gün sürecek ve 60 gün süren 3 turdan oluşacak, her tur arasında 5-10 gün aralık olacaktır.",
    cont2_btn1: 'Uzun dönem kiralama modu',
    cont2_btn2: 'Kısa dönem kiralama modu',
    cont3: {
      text1: 'Toplam Hesaplama \n Gücü Değeri',
      text2: 'Toplam GPU \n Sayısı',
      text3: 'Toplam Hesaplama \n Havuzu Sayısı',
      text4: 'GPU Kiralama \n Oranı',
      text5: 'Toplam DLC Ödülü',
      text6: 'Yok Edilen \n DLC Sayısı',
      text7: 'Madenciler İçin \n Rehin Verilen DLC Sayısı',
      text8: 'Çevrimiçi GPU Sayısı',
      text9: 'Çevrimiçi GPU Kiralama Oranı',
    },
    cont4: {
      li1: 'Yarışma Sıralaması',
      li2: 'Madenci Adı',
      li3: 'Hesaplama Gücü',
      li4: 'GPU Sayısı',
      li5: 'Kiralama Oranı',
      li6: 'Kiralama Sayısı',
      li7: 'Kilidi Açılmış Ödüller',
      li8: 'Toplam Ödüller',
      li9: 'Çevrimiçi GPU Sayısı',
      li10: 'Çevrimiçi GPU Kiralama Oranı',
    },
  },
  long_rule: {
    title: 'Uzun Dönem Kiralama Modu Yarışma Kuralları',
    text1: 'DeepLink ağındaki uzun dönem kiralama modundaki toplam GPU sayısı şu anda {long_num}',
    text2:
      "Yarışma sırasında madenciler toplamda 2 milyar DLC ödülü alabilirler ve kullanıcılar tarafından ödenen DLC kiralama ücretlerinin %100'ü yakılacaktır",
    competition_phase_two_in_progress: 'Yarışmanın ikinci aşaması devam ediyor',
    cont2: {
      title: '1. Katılım Kuralları',
      text1_1:
        "Orion hesaplama gücü yarışmasına katılan madencilerin bir Node NFT'ye sahip olmaları gerekir ( node hakkında daha fazla bilgi: ",
      text1_2:
        "). Yarışma sırasında, tek bir GPU makinesi birden fazla node'a sahip olabilir ve ödül tokenlarının sayısı node sayısıyla çarpılır. Makine başına maksimum Node NFT sayısı 20'dir.",
      text2_1:
        'GPU sunucu parametreleri için minimum gereksinimler: \n Hesaplama gücü sunucusunun minimum gereksinimleri karşılaması \n ve doğrulayıcının incelemesini geçerek çevrimiçi hale gelmesi gerekir, aksi takdirde gelir elde edemez.',
      text3_1: 'GPU',
      text3_2: 'Nvidia serisi bir grafik kartı olmalıdır; 20, 30, 40 veya 50 serisi modeller',
      text4_1: 'Bellek',
      text4_2: "Minimum gereksinim kart başına 16G'dir, 32G önerilir",
      text5_1: 'CPU',
      text5_2:
        "Bulut oyun gereksinimlerini karşılamalıdır: Intel/AMD, ana frekans 3.0GHz veya turbo frekans 3.5GHz üzeri; her GPU için ayrı bir CPU gereklidir ve Black Myth: Wukong'u sorunsuz bir şekilde çalıştırabilmelidir, örneğin Intel 10. nesil veya üzeri, AMD 5600 veya üzeri",
      text6_1: 'Sabit Disk',
      text6_2:
        'Sistem diski 100G SSD üzerinde olmalı, veri diski 3T SSD üzerinde olmalı veya disksiz bir sistem kullanılmalıdır',
      text7_1: 'Konum',
      text7_2:
        'Ağ ve elektrik kesintisi nedeniyle cezalardan kaçınmak için makineyi IDC veri merkezine yerleştirmek önerilir',
      text8_1: 'Ağ Bant Genişliği',
      text8_2: 'Her GPU makinesinin en az 10M yukarı akış bant genişliğine sahip olması önerilir',
    },
    cont3: {
      title: '2. Hesaplama Gücü Hesaplama Kuralları',
      text: "Tüm ekosistemdeki kullanıcı terminallerinin kira ücretleri, hesaplama gücü değeri sisteminin fiyatlandırmasına dayalı olarak birleştirilmiştir. DLC kira geliri 0,6 USD/C/ay'dır. Hesaplama modeli şu şekildedir: Tüm makine hesaplama gücü = (25 * kart sayısı + bellek/3,5 + (√(CUDA çekirdek sayısı) * √(bellek/10)) * GPU sayısı), yerel alan katsayısı 1 olduğunda hesaplama gücü değeri şu şekildedir:",
      li1: 'GPU Türü',
      li2: 'CUDA Çekirdekleri',
      li3: 'Bellek',
      li4: 'GPU Sayısı',
      li5: 'Bellek (G)',
      li6: 'Tüm Makine Hesaplama Gücü (C)',
      li7: 'Tüm Makine Kiralama (USD)',
      li8: 'Kart Başına Aylık Kiralama Oranı (USD)',
    },
    cont4: {
      title: '3. Bölgesel Katsayılar',
      li1: 'Bölge',
      li2: 'Katsayı',
      li_text1: 'Çin Anakarası',
      li_text2: 'Kuzey Amerika',
      li_text3: 'Güney Amerika',
      li_text4: 'Avrupa',
      li_text5: 'Orta Doğu',
      li_text6: 'Güney Kore',
      li_text7: 'Japonya',
      li_text8: 'Tayvan, Çin',
      li_text9: 'Hong Kong ve Makao, Çin',
      li_text10: 'Malezya',
      li_text11: 'Endonezya',
      li_text12: 'Singapur',
      li_text13: 'Vietnam',
      text1:
        'Makine hesaplama gücü hesaplama formülü: (25 * kart sayısı + bellek/3.5 + (√(CUDA çekirdek sayısı) * √(bellek/10)) * GPU sayısı) * bölgesel katsayı * büyük model katsayısı',
      text2: 'Makine Modeli:',
      text3: 'GPU Sayısı:',
      text4: 'Bellek Boyutu:',
      text5: 'Bölge:',
      text6: 'Lütfen Seçiniz',
      text7: 'Mevcut makinenin hesaplama gücü değeri: {total}',
    },
    cont5: {
      title:
        "4. Ödül Mekanizması (DBC AI Genel Zincirinde EVM uyumlu DLC'ye Dayalı, Tarayıcı Adresi: https://test.dbcscan.io/)",
      text1:
        'Orion hesaplama gücü yarışmasındaki IDC uzun dönem kiralama modu GPU makineleri için toplam token ödülü 2 milyar olup, 180 gün sürmektedir. Yarışma 3 turdan oluşur ve her tur arasında 5-10 günlük bir ara vardır.',
      text2: "Yarışma 1: Yarışma, her türden GPU sayısı {n_gpu1}'e ulaştığında resmen başlayacaktır.",
      text3:
        "60 gün, günde 6 milyon token, %10'u hemen alınır, %90'ı 180 gün boyunca kilidi açılır ve günlük %0.5 kilidi açılır.",
      text4: "Yarışma 2: Yarışma, her türden GPU sayısı {n_gpu2}'e ulaştığında resmen başlayacaktır.",
      text5:
        "60 gün, günde 8 milyon token, %10'u hemen alınır, %90'ı 180 gün boyunca kilidi açılır ve günlük %0.5 kilidi açılır.",
      text6: "Yarışma 3: Yarışma, her türden GPU sayısı {n_gpu3}'e ulaştığında resmen başlayacaktır.",
      text7:
        "60 gün, günde 19,33 milyon token, %10'u hemen alınır, %90'ı 180 gün boyunca kilidi açılır ve günlük %0.5 kilidi açılır.",
      text8: "Borsa listelendikten sonra, test token'ları ana ağ token'ları ile 1:1 oranında değiştirilebilir.",
      text9: 'DeepLink, doğrusal olmayan bir ödül algoritması kullanır.',
      text10:
        "Bu sistemde günlük ödül olarak verilen toplam token sayısı sabittir. Bir makinenin aldığı ödüller, makinenin işlem gücü X, etkin madencilik süresi Y ve yatırılan token miktarı ile ilişkilidir. Yatırılan token sayısı arttıkça ödüller de artar; ancak bu, doğrusal bir büyüme ilişkisini takip etmez. 0-10.000 token için ödül tabanı aynıdır, ancak 10.000 token'ı aştığında ödül bir fonksiyon temelinde hesaplanır. Makine kiralandığında işlem gücü %30 artar.",
      text11: 'Ödül Hesaplama Formülü:',
      text12: 'R: Günlük toplam ödül token miktarı (sabit değer)',
      text13: "Makine i'nin yatırılan token sayısı",
      text14: "Makine i'nin işlem gücü",
      text15: "Makine i'nin etkin madencilik süresi",
      text16: '',
      title1: 'Yatırılan Miktar:',
      text1_1: '1) İstediğiniz kadar token yatırabilir veya yatırım yapmamayı seçebilirsiniz.',
      text1_2:
        "2) 0-10.000 arası yatırılan miktar için ödül aynı kalır; 10.000'i aştığında ödüller doğrusal olmayan şekilde artar.",
      text1_3:
        "3) Yatırılan miktar 10.000'den az olduğunda, her ödül çekimi önce yatırıma eklenir ve 10.000'e ulaşana kadar devam eder.",
      text1_4:
        "4) 100.000 token için ödül, 10.000 token yatırımı için ödülün 1.23026 katıdır, bu yaklaşık %23.03'lük bir artıştır. 1.000.000 token için ödül, 1.46052 katı, yani %46.05'lik bir artış sağlar. 10.000.000 token için 1.69078 kat artışla yaklaşık %69.08 ve 100.000.000 token için 1.92103 kat yani yaklaşık %92.10 artış sağlar.",
      title2: 'Ödül Çekme:',
      text2_1:
        "Ödülleri her 24 saatte bir çekebilirsiniz. Her çekimde, yeni üretilen ödüllerin %10'u hemen çekilebilirken, %90'ı 180 gün boyunca kilitlenir. Kilitlenen kısım her çekim sırasında %0.5 oranında serbest bırakılır ve 180 gün sonra tamamen açılır.",
      block_title1: 'Özel Dikkat:',
      block_text1_1:
        'Uzun dönem kiralama modu, GPU makinesinin önce DBC ağına eklenmesini gerektirir. Referans doküman:',
      block_text1_2:
        '. Ardından madenciler makineyi kendileri kiralamalı ve ardından DLC ağına katılarak hem DBC hem de DLC gelirleri elde etmelidir. DBC ağına katıldıktan sonra DBC geliri = DBC ödülleri - %30 kira ücreti.',
      block_title2: 'Makinenin Günlük DBC Geliri Hesaplama Formülü:',
      block_text2:
        "Makinenin toplam hesaplama gücü / ağın toplam hesaplama gücü * 547,945 * DBC fiyatı * bölgesel katsayı * 1,3 (kiralandığında hesaplama gücü %30 artar) - makinenin toplam hesaplama gücü * bölgesel katsayı * 0,01693 * %30 (birim hesaplama gücü başına günlük gelir 0,01693 USD'dir).",
      text3_13:
        'Günlük mevcut gelir: {usdt1} USD eşdeğerinde DBC = Zincir üzerindeki ödüller: {dbc} DBC (mevcut DBC fiyatı {dbc_price} USD iken {usdt2} USD eşdeğeri) - %30 kira ücreti: {usdt3} USD eşdeğerinde DBC.',
      title4: 'Makinenin Günlük DLC Geliri Hesaplama Formülü: DLC {price} USD olarak hesaplanır.',
      text4_1: 'GPU Modeli:',
      text4_2: 'Bellek Miktarı:',
      text4_3: 'Düğüm NFT Sayısı:',
      text4_4: 'Bölge:',
      text4_5: 'Stake Edilen DLC Miktarı:',
      text4_6: 'Yarışma Aşaması:',
      text4_6_1: 'Aşama 1: Günlük 6 milyon DLC.',
      text4_6_2: 'Aşama 2: Günlük 8 milyon DLC.',
      text4_6_3: 'Aşama 3: Günlük 19,33 milyon DLC.',
      text4_7: 'Katılan GPU sayısı:',
      text4_8: '(Toplam GPU, 4060 modeli, 32GB, ortalama 10 NFT ve ortalama 100.000 token stake edilerek hesaplanır)',
      title5: 'Zincir üzerindeki ödüller: {dlc_num} DLC (mevcut DLC fiyatı {price} USD iken {usdt_num} USD eşdeğeri).',
      req_title1: "5. Bildirme ve Doğrulama Mekanizması (DBC AI Genel Zincirindeki EVM uyumlu DLC'ye dayalı)",
      req_text1:
        'DLC makinelerini kiralayan kullanıcılar istedikleri zaman bildirimde bulunabilirler. Bildirim başlatmak için 10.000 DLC depozitosu gereklidir. Bildirim sırasında bildirim bilgileri DBC doğrulayıcı doğrulama sürecine girer.',
      req_title2: "6. Ceza Mekanizması (DBC AI Genel Zincirindeki EVM uyumlu DLC'ye dayalı)",
      req_text2:
        "DLC bildirimi doğrulandıktan sonra doğrulamada sorun varsa, kurallara göre DBC stake edilen token'lar düşülür ve en fazla 10.000 DLC token düşülebilir. Bu stake edilen token'lar bildiren kullanıcıya ödül olarak verilir.",
      req_title3: "7. Ödeme ve Yakma Mekanizması (DBC AI Genel Zincirindeki EVM uyumlu DLC'ye dayalı)",
      req_text3:
        'Kullanıcılar DLC öder (DLC ağındaki GPU fiyatları DBC ağındaki GPU fiyatlarından %20 daha yüksektir) ve makinenin kiralama haklarını elde eder. Kullanıcılar tarafından ödenen DLC, %100 akıllı sözleşmede yakılır ve her ödeme ve yakma kaydı sorgulanabilir.',
    },
  },
  short_rule: {
    title: 'Kısa Süreli Kiralama Modu Yarışma Kuralları',
    text1: 'DeepLink ağında kısa süreli kiralama modundaki GPU sayısı şu anda {short_num}.',
    text2:
      'Yarışma sırasında, madenciler toplam 1 milyar DLC ödülü alabilir ve kullanıcıların ödediği DLC kiralama ücretleri %100 yakılacaktır.',
    competition_phase_two_in_progress: 'Yarışmanın dördüncü aşaması devam ediyor',
    cont2: {
      title: '1. Katılım Kuralları',
      text1_1:
        "Orion hesaplama gücü yarışmasına katılan madenciler, bir Düğüm NFT'sine sahip olmalıdır ( Düğümler hakkında daha fazla bilgi için:",
      text1_2:
        "). Yarışma sırasında, tek bir GPU makinesi birden fazla düğümü barındırabilir ve ödül tokenlerinin sayısı düğüm sayısına orantılıdır. Tek bir makinenin sahip olabileceği maksimum Düğüm NFT sayısı 20'dir.",
      text2_1:
        'GPU sunucusunun minimum gereksinimleri: \n Hesaplama sunucusunun parametreleri minimum gereksinimleri karşılamalıdır.',
      text3_1: 'GPU',
      text3_2: 'Nvidia serisi grafik kartı olmalıdır; modeller 20, 30, 40 ve 50 serisini içerir.',
      text4_1: 'Bellek',
      text4_2: "Her kart için minimum bellek gereksinimi 16G'dir, 32G önerilir.",
      text5_1: 'CPU',
      text5_2:
        "Bulut oyun gereksinimlerini karşılamalıdır: Intel/AMD, 3.0GHz temel frekans veya en az 3.5GHz artırma frekansı; her GPU için ayrı bir CPU gereklidir ve Black Myth: Wukong'u sorunsuz çalıştırabilmelidir. Örneğin: Intel 10. nesil veya üstü, AMD 5600 veya üstü.",
      text6_1: 'Sabit Disk',
      text6_2: 'Sistem diski 2T SSD veya üzeri, veri diski 1T veya üzeri',
      text7_1: 'Konum',
      text7_2: 'Makine evde kurulabilir.',
      text8_1: 'Ağ Bant Genişliği:',
      text8_2: 'Her GPU makinesi için en az 10M yükleme bant genişliği önerilir.',
    },
    cont3: {
      title: '2. Hesaplama Gücü Hesaplama Kuralları',
      text: "Tüm ekosistemde kullanıcıların kiralama ücretleri, hesaplama gücü değerine dayalı fiyatlandırma sistemi ile tek tip olarak belirlenir. DLC kira geliri 0.508 USD/C/ay'dır. Hesaplama modeli aşağıdaki gibidir: Tüm makinenin hesaplama gücü değeri = (25 * kart sayısı + bellek/3.5 + (√(CUDA çekirdek sayısı) * √(video belleği/10)) * grafik kartı sayısı).",
    },
    cont4: {
      title: '3. Bölgesel Katsayılar',
      li1: 'Bölge',
      li2: 'Katsayı',
      li_text1: 'Çin Anakarası',
      li_text2: 'Kuzey Amerika',
      li_text3: 'Güney Amerika',
      li_text4: 'Avrupa',
      li_text5: 'Orta Doğu',
      li_text6: 'Güney Kore',
      li_text7: 'Japonya',
      li_text8: 'Tayvan, Çin',
      li_text9: 'Hong Kong ve Makao, Çin',
      li_text10: 'Malezya',
      li_text11: 'Endonezya',
      li_text12: 'Singapur',
      li_text13: 'Vietnam',
      text1:
        'Makine hesaplama gücü hesaplama formülü: (25 * kart sayısı + bellek/3.5 + (√(CUDA çekirdek sayısı) * √(bellek/10)) * GPU sayısı) * büyük model katsayısı',
      text2: 'Makine Modeli:',
      text3: 'GPU Sayısı:',
      text4: 'Bellek Boyutu:',
      text5: 'Bölge:',
      text6: 'Lütfen Seçiniz',
      text7: 'Mevcut makinenin hesaplama gücü değeri: {total}',
    },
    cont5: {
      title:
        "4. Ödül Mekanizması (DBC AI Genel Zincirinin EVM uyumlu DLC'sine dayanmaktadır, tarayıcı adresi: https://test.dbcscan.io/)",
      text1:
        'Orion hesaplama gücü yarışmasında bireysel kısa süreli kiralık GPU makineleri için toplam token ödülü 1 milyar olup, 180 gün sürer. Yarışma 3 aşamaya ayrılmıştır ve her bir aşama arasında 5-10 gün ara verilir.',
      text2: "Yarışma Aşama 1: Her tür GPU sayısı {n_gpu1}'e ulaştığında yarışma resmi olarak başlar.",
      text3:
        '60 gün boyunca, günde 3 milyon token, %10 hemen serbest bırakılır, %90 ise 180 gün boyunca serbest bırakılır ve günlük %0,5 serbest bırakılır.',
      text4: "Yarışma Aşama 2: Her tür GPU sayısı {n_gpu2}'e ulaştığında yarışma resmi olarak başlar.",
      text5:
        '60 gün boyunca, günde 4 milyon token, %10 hemen serbest bırakılır, %90 ise 180 gün boyunca serbest bırakılır ve günlük %0,5 serbest bırakılır.',
      text6: "Yarışma Aşama 3: Her tür GPU sayısı {n_gpu3}'e ulaştığında yarışma resmi olarak başlar.",
      text7:
        '60 gün boyunca, günde 9,665 milyon token, %10 hemen serbest bırakılır, %90 ise 180 gün boyunca serbest bırakılır ve günlük %0,5 serbest bırakılır.',
      text8: "Borsa listelendikten sonra, test token'ları ana ağ token'ları ile 1:1 oranında değiştirilebilir.",
      text9: 'DeepLink, doğrusal olmayan bir ödül algoritması kullanır.',
      text10:
        "Bu sistemde günlük ödül olarak verilen toplam token sayısı sabittir. Bir makinenin aldığı ödüller, makinenin işlem gücü X, etkin madencilik süresi Y ve yatırılan token miktarı ile ilişkilidir. Yatırılan token sayısı arttıkça ödüller de artar; ancak bu, doğrusal bir büyüme ilişkisini takip etmez. 0-10.000 token için ödül tabanı aynıdır, ancak 10.000 token'ı aştığında ödül bir fonksiyon temelinde hesaplanır. Makine kiralandığında işlem gücü %30 artar.",
      text11: 'Ödül Hesaplama Formülü:',
      text12: 'R: Günlük toplam ödül token miktarı (sabit değer)',
      text13: "Makine i'nin yatırılan token sayısı",
      text14: "Makine i'nin işlem gücü",
      text15: "Makine i'nin etkin madencilik süresi",
      text16: '',
      title1: 'Yatırılan Miktar:',
      text1_1: '1) İstediğiniz kadar token yatırabilir veya yatırım yapmamayı seçebilirsiniz.',
      text1_2:
        "2) 0-10.000 arası yatırılan miktar için ödül aynı kalır; 10.000'i aştığında ödüller doğrusal olmayan şekilde artar.",
      text1_3:
        "3) Yatırılan miktar 10.000'den az olduğunda, her ödül çekimi önce yatırıma eklenir ve 10.000'e ulaşana kadar devam eder.",
      text1_4:
        "4) 100.000 token için ödül, 10.000 token yatırımı için ödülün 1.23026 katıdır, bu yaklaşık %23.03'lük bir artıştır. 1.000.000 token için ödül, 1.46052 katı, yani %46.05'lik bir artış sağlar. 10.000.000 token için 1.69078 kat artışla yaklaşık %69.08 ve 100.000.000 token için 1.92103 kat yani yaklaşık %92.10 artış sağlar.",
      title2: 'Ödül Çekme:',
      text2_1:
        'Ödüller herhangi bir zamanda çekilebilir. Başlangıçta DLC stake etmediyseniz veya stake edilen miktar 10,000’den azsa, ödül kârları 10,000 DLC’ye ulaşana kadar stake edilen DLC olarak birikir.<br>1) Kira, 10,000 DLC’ye ulaşana kadar stake fonu olarak birikir.<br>2) Minimum kiralama süresi 2 saattir, maksimum kiralama süresi sınırsızdır. Kalan kullanılabilir süre 1 saatten az olduğunda, makine kiralanamaz ve çevrimiçi ödüllere dahil edilmez. Madenciler süreyi herhangi bir zamanda uzatabilir, ancak her uzatma en az 2 saat olmalıdır.',

      title4: 'Günlük DLC Gelir Hesaplama Formülü: DLC, {price} USD fiyatıyla hesaplanır.',
      text4_8:
        '(Toplam GPU, 4060 32G baz alınarak, ortalama 10 NFT ve ortalama 10.000 token stake edilerek hesaplanır)',
      title5:
        "Zincir Üzeri Ödül Kazançları: {dlc_num} DLC (mevcut DLC fiyatı {price} USD olduğunda {usdt_num} USD'ye eşdeğer).",

      req_title1: '5. Çevrimiçi Algılama Mekanizması',
      req_text1_1:
        'Makine, DBC AI genel zincirinin algılama mekanizmasına tabidir ve makinenin çevrimiçi olup olmadığını belirlemek için DBC dağıtılmış algılama kümesine bilgi rapor eder. Çevrimiçi değilse çevrimiçi ödüller düşülecektir. Kullanım sırasında kesintiler olursa, kullanıcıdan DLC düşülecektir. Ceza sınırları:',
      req_text1_2:
        '1) Hiçbir coin stake edilmediyse, yalnızca mevcut kira DLC gelirleri ceza olarak kesilir ve maksimum 2 saat kira ücreti ceza olarak uygulanır.',
      req_text1_3: '2) DLC stake edildiyse, 1.000 DLC ceza uygulanır.',
      req_text1_4:
        'Makinede DBC AI blok zincirinin sürekli bir tespit mekanizması bulunur ve makinenin çevrimiçi durumunu belirlemek için bilgileri DBC dağıtılmış tespit kümesine bildirir. Çevrimiçi değilse, çevrimiçi ödüller kesilir. Kullanım sırasında kesintiler olursa, kullanıcıdan DLC kesilir. Şu anda her kesinti için 1000 DLC ceza uygulanır ve bu daha sonra DLC fiyatına göre dinamik olarak değişecektir',
      req_title2: '6. Makine Bildirim Kuralları',
      req_text2:
        'Herhangi bir kullanıcı, makinenin yapılandırmasının sahte olabileceğini düşünürse bildirim başlatabilir. Başarılı olursa, makinedeki tüm stake edilmiş coinler kesilir ve ödüller durdurulur.',
      req_title3: '10.000 DLC stake edin ve bildirim bilgilerini zincire gönderin',
      req_text3:
        'DeepLink tarafından yetkilendirilmiş doğrulayıcılar doğrulamaya katılabilir, her doğrulamada 5 doğrulayıcı yer alır ve çoğunluk kuralı uygulanır.',

      text4_6_1: 'Aşama 1: Günde 3 milyon DLC.',
      text4_6_2: 'Aşama 2: Günde 4 milyon DLC.',
      text4_6_3: 'Aşama 3: Günde 9,665 milyon DLC.',
      text4_6_4: 'Aşama 4: Günde 9,665 milyon DLC.',
      text4_6_5: 'Aşama 5: Günde 9,665 milyon DLC.',
    },
  },
  country: {
    country1: 'Çin',
    country2: 'Kuzey Amerika',
    country3: 'Güney Amerika',
    country4: 'Avrupa',
    country5: 'Orta Doğu',
    country6: 'Güney Kore',
    country7: 'Japonya',
    country8: 'Tayvan, Çin',
    country9: 'Hong Kong ve Makao, Çin',
    country10: 'Malezya',
    country11: 'Endonezya',
    country12: 'Singapur',
    country13: 'Vietnam',
  },
  device: {
    title: 'Ağdaki Cihaz Listesi',
    title1: 'Farklı GPU modellerine ait makine sayısını, makine durumunu ve ayrıntılı bilgileri görüntüleyin.',
    table: {
      text1: 'Makine Kullanım Durumu:',
      text2: 'GPU Sayısı:',
      text3: 'Toplam Makine Sayısı:',
      text4: 'Boşta Olan Makine Sayısı:',
    },
  },
  machine_id: 'Makine Kimliği',
  machine_is_rented: 'Kiralık mı',
  machine_rented: 'Kiralandı',
  machine_idle: 'Boşta',
  machine_is_online: 'Çevrimiçi mi',
  machine_yes: 'Evet',
  machine_no: 'Hayır',
  machine_no_data: 'Veri yok',

  deviceUniqueId: 'Makine Kimliği',
  minerLocation: 'Madenci Adresi',
  gpuCount: 'GPU Miktarı',
  computeCapacity: 'Toplam Hesaplama Gücü',
  isActive: 'Çevrimiçi Durum',
  isPledged: 'Stake Durumu',
  pledgeTotal: 'Toplam Stake Miktarı',
  pledgeExpiration: 'Stake Bitiş Zamanı',

  yesOption: 'Evet',
  noOption: 'Hayır',
  gpuType: 'GPU Türü',
};
